<template>
  <div class="vld-parent" :class="{ 'vld-parent-loading': isLoading }">
    <loading
      :active="isLoading"
      :can-cancel="false"
      :on-cancel="onCancel"
      :is-full-page="true"
      :color="loadingColor"
      :height="loadingHeight"
      :width="loadingWidth"
    ></loading>
    
    <div class="header container-fluid mt-6" v-if="isLoading == false && incidencia">
      <div class="col-12 text-right">
        <base-button
          size="sm"
          type="warning"
          @click="modals.form = true"
          v-if="puedeResolverIncidencia"
          class="ml-2"
        >
          <i class="fas fa-check-circle mr-1"></i>
          Resolver Incidencia
        </base-button>
        <base-button size="sm" type="neutral" @click="revision()">
          Solicitar revisión
        </base-button>
        <base-button
          @click="goBack"
          type="button"
          class="btn btn-sm btn-primary ml-2"
          >Volver</base-button
        >
      </div>
      <div class="row">
        <div class="col-xl-12">
          <!-- CARD INCIDENCIA -->
          <card>
            <div
              class="h2 card-header border-0 pt-md-4 pb-0 pb-md-4 text-primary"
            >
              Datos básicos
            </div>
            <div class="card-body pt-0">
              <div class="row">
                <div class="col-lg-12">
                  <!-- PRIMERA FILA -->
                  <div class="row align-items-center">
                    <!--PRIORIDAD -->
                    <div class="col">
                      <span>Prioridad</span>

                      <h3 class="mb-0">
                        <span
                          class="badge badge-default"
                          :style="[
                            incidencia.prioridad == 'Alta'
                              ? { backgroundColor: 'red' }
                              : { backgroundColor: 'orange' },
                          ]"
                          >{{ incidencia.prioridad }}</span
                        >
                      </h3>
                    </div>
                    <!-- ESTADO -->
                    <div class="col">
                      <span>Estado</span>

                      <h3 class="mb-0">
                        <span
                          class="badge badge-default"
                          :style="[
                            incidencia.estado_incidencia.data.attributes
                              .nombre == 'Abierta'
                              ? { backgroundColor: 'info' }
                              : { backgroundColor: 'green' },
                          ]"
                          >{{
                            incidencia.estado_incidencia.data.attributes
                              .nombre == "Abierta"
                              ? "Inciencia Abierta"
                              : "Incidencia Cerrada"
                          }}</span
                        >
                      </h3>
                    </div>
                    <!-- TIPO -->
                    <div class="col">
                      <span>Tipo</span>
                      <h3 class="mb-0" style="text-transform: uppercase">
                        {{
                          incidencia.tipo_incidencia.data.attributes.descripcion
                        }}
                      </h3>
                    </div>
                  </div>
                  <!-- SEGUNDA FILA -->
                  <div class="row align-items-center" style="margin-top: 20px">
                    <!-- USUARIO -->
                    <div class="col">
                      <span>Incidencia creada por</span>

                      <h3 class="mb-0">
                        <!-- Avatar -->
                        <img
                          v-if="
                            incidencia.usuario.data.attributes.imagen_perfil &&
                            incidencia.usuario.data.attributes.imagen_perfil
                              .data.attributes.url
                          "
                          :src="
                            incidencia.usuario.data.attributes.imagen_perfil
                              .data.attributes.url
                          "
                          class="avatar rounded-circle"
                        />
                        <img
                          v-else
                          src="/img/placeholder.png"
                          class="avatar rounded-circle"
                        />
                        <a
                          :href="
                            '/user-management/edit-user/' +
                            incidencia.usuario.data.id
                          "
                          class="font-weight-bold"
                        >
                          <b>
                            {{
                              incidencia.usuario.data.attributes.nombre +
                              " " +
                              incidencia.usuario.data.attributes.apellidos
                            }}</b
                          ></a
                        >
                      </h3>
                    </div>
                    <!-- FECHA -->
                    <div class="col">
                      <span>Fecha de creación</span>
                      <h3 class="mb-0">
                        {{
                          moment(incidencia.createdAt).format(
                            "DD/MM/YYYY HH:mm"
                          )
                        }}
                        ({{ moment(incidencia.createdAt).fromNow() }})
                      </h3>
                    </div>
                    <!-- VACÍO -->
                    <div class="col"></div>
                  </div>
                </div>
              </div>
            </div>
          </card>
          <!-- MOTIVO -->
          <div class="card">
            <div
              class="h2 card-header border-0 pt-md-4 pb-0 pb-md-4 text-primary"
            >
              Motivo
            </div>
            <div class="card-body pt-0">
              <h3 class="mb-4">
                {{
                  incidencia.descripcion === ""
                    ? "El usuario no ha escrito el motivo"
                    : incidencia.descripcion
                }}
              </h3>

              <h3 class="mb-0">
                <button
                  type="button"
                  class="btn-icon-clipboard"
                  style="width: auto"
                  @click="sendMessage(incidencia.usuario.data.id)"
                >
                  <div>
                    <span class="btn-inner--icon"
                      ><i class="ni ni-send"></i
                    ></span>
                    <span style="font-size: medium; font-weight: 600"
                      >Enviar mensaje al usuario que ha creado la
                      incidencia</span
                    >
                  </div>
                </button>
              </h3>
            </div>
          </div>
          
          <!-- RESOLUCIÓN (si la incidencia está resuelta) -->
          <card
            v-if="incidencia.resolucion && incidencia.resolucion.trim() !== ''"
            class="border border-success"
          >
            <div
              class="h2 card-header border-0 pt-md-4 pb-0 pb-md-4 text-success"
            >
              <i class="fas fa-check-circle mr-2"></i>
              Resolución de la Incidencia
            </div>
            <div class="card-body pt-0">
              <div class="row">
                <div class="col-lg-12">
                  <div class="rounded p-4 border border-success" style="background-color: #fafafa;">
                    <div class="mb-3">
                      <h5 class="text-success mb-2">
                        <i class="fas fa-check-circle mr-2"></i>
                        Incidencia Resuelta
                      </h5>
                      <div class="text-dark" style="white-space: pre-wrap; line-height: 1.6; font-size: 1rem;">
                        {{ incidencia.resolucion }}
                      </div>
                    </div>
                    <hr class="my-3">
                    <div class="text-dark">
                      <small class="font-weight-bold">
                        <i class="fas fa-calendar mr-2 text-success"></i>
                        Resuelta el {{ 
                          incidencia.updatedAt 
                            ? moment(incidencia.updatedAt).format("DD/MM/YYYY HH:mm")
                            : 'Fecha no disponible'
                        }}
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
          <!-- CARD IMAGENES -->
          <div class="card">
            <div
              class="h2 card-header border-0 pt-md-4 pb-0 pb-md-4 text-primary"
            >
              Imágenes
            </div>
            <div
              class="card-body pt-0"
              v-if="this.incidencia.incidence_documents.data"
            >
              <img
                v-for="image in incidence_documents.data"
                :src="image.attributes.url"
                v-bind:key="image.id"
                style="height: 200px !important; padding-left: 20px"
              />
            </div>
            <div class="card-body pt-0" v-else>
              <h4>No se han adjuntado imágenes a la incidencia.</h4>
            </div>
          </div>
          <!-- CARD INFORME -->
          <card>
            <div
              class="h2 card-header border-0 pt-md-4 pb-0 pb-md-4 text-primary"
            >
              Documentos
            </div>
            <div class="card-body pt-0">
              <h3 class="mb-0">
                <button
                  type="button"
                  class="btn-icon-clipboard"
                  style="width: auto"
                  @click="downloadAdditionalFile(incidencia)"
                >
                  <div>
                    <span class="btn-inner--icon"
                      ><i class="fas fa-download"></i
                    ></span>
                    <span style="font-size: medium; font-weight: 500"
                      >Descargar Informe de la incidencia</span
                    >
                  </div>
                </button>
              </h3>
            </div>
          </card>
          <!-- USUARIO -->
          <card>
            <div
              class="h2 card-header border-0 pt-md-4 pb-0 pb-md-4 text-primary"
            >
              Usuario
            </div>

            <div class="card-body pt-0">
              <div class="row" v-if="incidencia.usuario.data !== null">
                <div class="col-lg-12">
                  <div class="row align-items-center" style="margin-left: auto">
                    <!-- Avatar -->

                    <img
                      v-if="
                        incidencia.usuario.data.attributes.imagen_perfil &&
                        incidencia.usuario.data.attributes.imagen_perfil.data
                          .attributes.url
                      "
                      :src="
                        incidencia.usuario.data.attributes.imagen_perfil.data
                          .attributes.url
                      "
                      class="avatar rounded-circle"
                    />
                    <img
                      v-else
                      src="/img/placeholder.png"
                      class="avatar rounded-circle"
                    />
                    <!-- <img
                        alt="Image placeholder"
                        src="https://demos.creative-tim.com/argon-dashboard-pro-bs4/assets/img/theme/team-4.jpg"
                      /> -->

                    <div class="col-lg-3">
                      <span>Nombre y Apellidos</span>

                      <h3 class="mb-0">
                        {{
                          incidencia.usuario.data.attributes.nombre +
                          " " +
                          incidencia.usuario.data.attributes.apellidos
                        }}
                      </h3>
                    </div>
                    <div class="col-lg-3">
                      <span>Correo electrónico</span>
                      <h3 class="mb-0">
                        {{ incidencia.usuario.data.attributes.email }}
                      </h3>
                    </div>
                    <div class="col-lg-2">
                      <span>Rol</span>
                      <h3 class="mb-0">
                        {{
                          incidencia.usuario.data.attributes.role.data
                            .attributes.name
                        }}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" v-else>
                <div class="col-lg-12">
                  <h4>
                    Este equipo no está asignado a ningún usuario y se encuentra
                    disponible.
                  </h4>
                </div>
                <div class="col-lg-4">
                  <div class="col">
                    <button
                      type="button"
                      class="btn-icon-clipboard"
                      @click="assign()"
                    >
                      <div>
                        <span class="btn-inner--icon"
                          ><i class="fas fa-user-plus"></i
                        ></span>
                        <span style="font-size: medium; font-weight: 500"
                          >Asignar este equipo a un usuario</span
                        >
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <router-link
              :to="'/user-management/edit-user/' + incidencia.usuario.data.id"
              class="dropdown-item text-center text-primary font-weight-bold py-3"
              >Ver usuario</router-link
            >
          </card>
          <!-- CARD EQUIPO-->
          <card>
            <div
              class="h2 card-header border-0 pt-md-4 pb-0 pb-md-4 text-primary"
            >
              Equipo
            </div>
            <div class="card-body pt-0">
              <div class="row">
                <div class="col-lg-3">
                  <div
                    v-if="
                      incidencia.activo.data.attributes.modelo.data.attributes
                        .imagen.data
                    "
                  />
                  <img
                    v-if="
                      incidencia.activo.data.attributes.modelo.data.attributes
                        .imagen.data
                    "
                    :src="
                      incidencia.activo.data.attributes.modelo.data.attributes
                        .imagen.data.attributes.url
                    "
                    style="width: 100%"
                  />
                </div>

                <div class="col-lg-9">
                  <div style="margin-bottom: 20px">
                    <span
                      class="badge badge-lg"
                      style="color: white; background-color: red"
                      variant="success"
                      >EQUIPO CON INCIDENCIA</span
                    >
                  </div>
                  <div class="row align-items-center">
                    <div class="col">
                      <span>Categoría</span>
                      <h3 class="mb-0">
                        {{
                          incidencia.activo.data.attributes.subtipo.data
                            .attributes.nombre
                        }}
                      </h3>
                    </div>
                    <div class="col">
                      <span>Modelo</span>
                      <h3 class="mb-0">
                        {{
                          incidencia.activo.data.attributes.modelo.data
                            .attributes.nombre
                        }}
                      </h3>
                    </div>
                    <div class="col">
                      <span>Marca</span>
                      <h3 class="mb-0">
                        {{
                          incidencia.activo.data.attributes.fabricante.data
                            .attributes.nombre
                        }}
                      </h3>
                    </div>
                  </div>
                  <div class="row align-items-center" style="margin-top: 20px">
                    <div class="col">
                      <span>Identificador</span>
                      <h3 class="mb-0">
                        {{ incidencia.activo.data.attributes.nombre }}
                      </h3>
                    </div>
                    <div class="col">
                      <span>Número de serie</span>
                      <h3 class="mb-0">
                        {{ incidencia.activo.data.attributes.numero_serie }}
                      </h3>
                    </div>
                    <div class="col">
                      <span>Normativa</span>
                      <h3 class="mb-0">
                        {{ incidencia.activo.data.attributes.normativa }}
                      </h3>
                    </div>
                  </div>
                  <div class="row align-items-center" style="margin-top: 20px">
                    <div class="col">
                      <span>Fecha fabricación</span>
                      <h3 class="mb-0">
                        {{
                          moment(
                            incidencia.activo.data.attributes.fecha_fabricacion
                          ).format("DD/MM/YYYY")
                        }}
                        ({{
                          moment(
                            incidencia.activo.data.attributes.fecha_fabricacion
                          ).fromNow()
                        }})
                      </h3>
                    </div>
                    <div class="col">
                      <span>Fecha Puesta en Servicio</span>
                      <h3 class="mb-0">
                        {{
                          moment(
                            incidencia.activo.data.attributes.fecha_adquisicion
                          ).format("DD/MM/YYYY")
                        }}
                        ({{
                          moment(
                            incidencia.activo.data.attributes.fecha_adquisicion
                          ).fromNow()
                        }})
                      </h3>
                    </div>
                    <div class="col">
                      <span>Fecha próxima revisión</span>
                      <h3 class="mb-0">
                        {{
                          moment(
                            incidencia.activo.data.attributes
                              .fecha_prox_revision
                          ).format("DD/MM/YYYY")
                        }}
                        ({{
                          moment(
                            incidencia.activo.data.attributes
                              .fecha_prox_revision
                          ).fromNow()
                        }})
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <router-link
              :to="
                '/activo-management/view-activo/' + incidencia.activo.data.id
              "
              class="dropdown-item text-center text-primary font-weight-bold py-3"
              >Ver equipo</router-link
            >
          </card>
        </div>
      </div>
      <!--Form modal-->
      <modal :show.sync="modals.form" size="md" body-classes="p-0">
        <card
          type="secondary"
          header-classes="bg-transparent pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0 mb-0"
        >
          <template>
            <div class="text-center mb-4">
              <h5 class="text-primary">
                <i class="fas fa-check-circle mr-2"></i>
                Resolver Incidencia
              </h5>
              <p class="text-muted small mb-0">
                Describe cómo se resolvió la incidencia
              </p>
            </div>
            <form role="form" @submit.prevent="resolver()">
              <div class="form-group">
                <label class="form-control-label">
                  <strong>Comentario de Resolución:</strong>
                </label>
                <textarea
                  class="form-control"
                  v-model="message"
                  rows="5"
                  placeholder="Describe detalladamente cómo se resolvió la incidencia, qué acciones se tomaron, etc."
                  required
                ></textarea>
                <small class="form-text text-muted">
                  Este comentario quedará registrado en el historial de la incidencia.
                </small>
              </div>

              <div class="text-center">
                <base-button
                  outline
                  type="secondary"
                  style="width: auto; margin-right: 10px"
                  @click="modals.form = false"
                >
                  Cancelar
                </base-button>
                <base-button
                  type="warning"
                  style="width: auto"
                  @click="resolver()"
                  :disabled="!message || !message.trim()"
                >
                  <i class="fas fa-check-circle mr-1"></i>
                  Resolver Incidencia
                </base-button>
              </div>
            </form>
          </template>
        </card>
      </modal>
    </div>

    <!-- DIALOG SOLICITUD REVISIÓN -->
    <el-dialog
      title="Solicitar revisión a Misepis"
      :visible.sync="dialogFormVisibleRev"
      width="60%"
    >
      <div class="col-auto">
        <p>
          Si aceptas se enviará una solicitud para realizar una revisión de este
          equipo.
        </p>
        <ul>
          <li>
            Identificador: <b>{{ incidencia.activo.data.attributes.nombre }}</b
            >. Número de serie:
            <b>{{ incidencia.activo.data.attributes.numero_serie }}</b>
          </li>
        </ul>
      </div>

      <span slot="footer" class="dialog-footer">
        <base-button @click="dialogFormVisibleRev = false" type="secondary"
          >Cancelar</base-button
        >

        <base-button @click="revisionPost" type="primary">Aceptar</base-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import formMixin from "@/mixins/form-mixin";
import { Select, Option, Dialog } from "element-ui";
import { cloneDeep } from "lodash";
import moment from "moment";
import axios from "axios";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "moment/locale/es";
moment.locale("es");

export default {
  layout: "DashboardLayout",
  components: {
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog
  },
  mixins: [formMixin],

  data() {
    return {
      isLoading: true, // Iniciar en true para mostrar loading inmediatamente
      loadingColor: "#7f1058",
      loadingHeight: 128,
      loadingWidth: 128,
      initial: true,
      incidence_documents: [],
      image: "",
      file: null,
      modals: {
        form: false,
      },
      formModal: {
        email: "",
        message: "",
      },
      message: "",
      dialogFormVisibleRev: false,
      incidencia: {
        type: "incidencias",
        createdAt: null,
        descripcion: null,
        activo: {
          id: null,
        },
        usuario: {
          id: null,
        },
        tipo_incidencia: {
          id: null,
        },
        estado_incidencia: {
          id: null,
        },

        resolucion: "",
        pdf: null,
        prioridad: null,
      },
      notificacion: {
        type: "notificaciones",
        descripcion: null,
        estado_notificacion: {
          id: 1, //pendiente de enviar
        },
        tipo_notificacion: {
          id: 3, //tipo: revision
        },
        usuario_origen: {
          id: null,
        },
        usuario_destino: {
          id: null,
        },
        empresa: {
          id: null,
        },
        activos: {},
      },
    };
  },
  beforeMount() {
    // Asegurar que isLoading esté en true antes del montaje
    this.isLoading = true;
  },
  created() {
    this.initial = true;
    this.isLoading = true;
    // No iniciar la carga hasta que el componente esté completamente montado
  },
  mounted() {
    // Iniciar la carga después de que el componente esté montado
    // Esto asegura que el loading se renderice primero
    console.log('Componente montado, iniciando carga, isLoading:', this.isLoading);
    this.$nextTick(() => {
    this.get();
    });
  },

  watch: {},
  methods: {
    onCancel() {
      console.log("User cancelled the loader.");
    },
    
    async get() {
      // Asegurar que isLoading esté en true
      if (!this.isLoading) {
      this.isLoading = true;
      }
      console.log('Iniciando carga de incidencia, isLoading:', this.isLoading);
      // Forzar actualización del DOM y dar tiempo para que se renderice el loading
      await this.$nextTick();
      // Dar un pequeño delay para asegurar que el loading se renderice
      await new Promise(resolve => setTimeout(resolve, 100));
      try {
        const id = this.$route.params.id;
        // El loading del store se maneja automáticamente en la acción
        await this.$store.dispatch("incidencias/get", id);
        this.incidencia = this.$store.getters["incidencias/incidencia"];

        this.incidence_documents = this.incidencia.incidence_documents;
        await this.$store.dispatch("profile/me");
        let me = await this.$store.getters["profile/me"];
        this.notificacion.usuario_origen.id = me.id;
        var planta = localStorage.getItem("plantaSelected");
        this.notificacion.empresa.id = planta;
        console.log(this.incidencia);
      } catch (error) {
        console.error("Error loading incidencia:", error);
        this.$notify({
          type: "danger",
          message: "Error al cargar los datos de la incidencia"
        });
      } finally {
        this.isLoading = false;
        console.log('Finalizando carga de incidencia, isLoading:', this.isLoading);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    removeImage() {
      this.image = null;
    },
    revision() {
      this.dialogFormVisibleRev = true;
    },
    async revisionPost() {
      var activo = this.incidencia.activo.data.attributes;
      let html_activos =
        "<ul><li> Identificador: <b>" +
        activo.nombre +
        "</b>. Número de serie: <b>" +
        activo.numero_serie +
        "</b></li></ul>";

      this.notificacion.activos = html_activos;
      // this.notificacion.activos = this.multipleSelection;
      console.log("NOTIFICACIÓN:");
      console.log(this.notificacion);

      try {
        await this.$store.dispatch("notificaciones/add", this.notificacion);
        this.$notify({
          type: "success",
          message: "La solicitud se ha enviado correctamente.",
        });
        this.dialogFormVisibleRev = false;
        //this.$router.go(0);
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "danger",
          message: "Oops, algo ha ido mal",
        });
        this.setApiValidation(error.response.data.error.details.errors);
      }
    },
    async resolver() {
      // Validar que haya un mensaje de resolución
      if (!this.message || !this.message.trim()) {
        this.$notify({
          type: "warning",
          message: "Debes agregar un comentario de resolución"
        });
        return;
      }

      // Obtener el ID de la incidencia (puede estar en diferentes formatos)
      const incidenciaId = this.incidencia.id || 
                          this.incidencia.data?.id ||
                          this.incidencia.attributes?.id;

      // Preparar los datos de la incidencia en el formato correcto para Strapi
      // El servicio envuelve esto en { data: ... }
      const incidenciaUpdate = {
        id: incidenciaId,
        resolucion: this.message.trim(),
        estado_incidencia: {
          id: 2 // ID del estado "Resuelta"
        },
        fecha_resolucion: new Date().toISOString() // Fecha actual en formato ISO
      };

      // Mantener los documentos relacionados si existen
      if (this.incidencia.incidence_documents && this.incidencia.incidence_documents.data) {
      var incidencias = [];
      this.incidencia.incidence_documents.data.forEach((document) => {
        incidencias.push(document.id);
      });
        incidenciaUpdate.incidence_documents = incidencias;
      } else if (this.incidencia.attributes?.incidence_documents?.data) {
        incidenciaUpdate.incidence_documents = this.incidencia.attributes.incidence_documents.data.map(doc => doc.id);
      }

      console.log('Resolviendo incidencia con formato:', incidenciaUpdate);

      try {
        await this.$store.dispatch("incidencias/update", incidenciaUpdate);
        
        // Cerrar el modal
        this.modals.form = false;
        this.message = '';
        
        this.$notify({
          type: "success",
          message: "Incidencia resuelta correctamente.",
        });
        
        // Recargar los datos de la incidencia para mostrar el estado actualizado
        await this.get();
      } catch (error) {
        console.error('Error al resolver la incidencia:', error);
        this.$notify({
          type: "danger",
          message: `Error al resolver la incidencia: ${error.response?.data?.error?.message || error.message || 'Error desconocido'}`
        });
        if (error.response?.data?.error?.details?.errors) {
        this.setApiValidation(error.response.data.error.details.errors);
        }
      }
    },

    downloadAdditionalFile(element) {
      console.log(element);

      const url_adicional = element.pdf;

      console.log(url_adicional);

      if (url_adicional) {
        window.open(url_adicional, "_blank");
      } else {
        this.$notify({
          type: "danger",
          message: `No se puede abrir el documento`,
        });
      }
    },
    sendMessage(userId) {
      console.log("Enviar Mensaje a: ", userId);
      this.$router.push({
        name: "Add notificacion to user",
        params: { id: userId },
      });
    },
  },
  computed: {
    // Verificar si la incidencia puede ser resuelta (no está resuelta)
    puedeResolverIncidencia() {
      if (!this.incidencia || !this.incidencia.estado_incidencia) {
        return false;
      }
      
      // Verificar por ID (2 = Resuelta)
      const estadoId = this.incidencia.estado_incidencia.data?.id || this.incidencia.estado_incidencia.id;
      if (estadoId === 2) {
        return false;
      }
      
      // Verificar por nombre (Resuelta)
      const estadoNombre = this.incidencia.estado_incidencia.data?.attributes?.nombre || 
                           this.incidencia.estado_incidencia.nombre;
      if (estadoNombre && estadoNombre.toLowerCase() === 'resuelta') {
        return false;
      }
      
      return true;
    }
  }
};
</script>
<style>
.profile-header {
  background-image: url(/img/theme/profile-cover.jpg);
  background-size: cover;
  background-position: center top;
  min-height: 500px;
}

.vld-parent {
  min-height: 100vh;
  position: relative;
}

.vld-parent-loading {
  overflow: hidden;
}

/* Asegurar que el loading esté por encima del footer y otros elementos */
.vld-overlay {
  z-index: 99999 !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
}

.vld-overlay .vld-background {
  background: rgba(255, 255, 255, 0.95) !important;
  z-index: 99999 !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
}

.vld-overlay .vld-icon {
  z-index: 100000 !important;
  position: relative !important;
}
</style>
